import { helper } from '@ember/component/helper';
import { pluralize } from '@linc-technologies/linced-common/utils/inflector';

// Usage: {{pluralize "ox"}}, {{pluralize this.count "ox"}} or
// {{pluralize this.count "ox" without-count=true}}.
export default helper(function pluralizeHelper(
  params: [number | string] | [number | string, string | null | undefined],
  { 'without-count': withoutCount }: { 'without-count'?: boolean },
): string {
  return params.length === 1
    ? pluralize(params[0] as string)
    : pluralize(params[0], params[1], { withoutCount });
});
